/**
 * Recharge remains interactive while its confirmed energy/price changes.
 * The sheet is a small HTML-only tree: keep matching nodes (especially the
 * dialog and its pressed button) instead of restarting them with innerHTML.
 * Never use this patcher on a Phaser host or on an editable form.
 */
function patchNode(current: Node, next: Node): void {
  if (current.nodeType === Node.TEXT_NODE && next.nodeType === Node.TEXT_NODE) {
    if (current.nodeValue !== next.nodeValue) current.nodeValue = next.nodeValue;
    return;
  }
  if (!(current instanceof Element) || !(next instanceof Element)) return;
  for (const attribute of [...current.attributes]) {
    if (!next.hasAttribute(attribute.name)) current.removeAttribute(attribute.name);
  }
  for (const attribute of [...next.attributes]) {
    if (current.getAttribute(attribute.name) !== attribute.value) current.setAttribute(attribute.name, attribute.value);
  }
  const desired = [...next.childNodes];
  for (let index = 0; index < desired.length; index += 1) {
    const nextChild = desired[index];
    if (nextChild === undefined) continue;
    const child = current.childNodes[index];
    if (child === undefined) {
      current.appendChild(nextChild.cloneNode(true));
    } else if (child.nodeType === nextChild.nodeType && (
      !(child instanceof Element) || (nextChild instanceof Element && child.tagName === nextChild.tagName)
    )) {
      patchNode(child, nextChild);
    } else {
      current.replaceChild(nextChild.cloneNode(true), child);
    }
  }
  while (current.childNodes.length > desired.length && current.lastChild !== null) current.lastChild.remove();
}

function patchSheet(host: HTMLElement, markup: string, selector: string): void {
  const current = host.querySelector<HTMLElement>(selector);
  if (current === null) {
    host.innerHTML = markup;
    return;
  }
  const template = document.createElement("template");
  template.innerHTML = markup;
  const next = template.content.querySelector<HTMLElement>(selector);
  if (next !== null) patchNode(current, next);
}

export function patchEnergySheet(host: HTMLElement, markup: string): void {
  patchSheet(host, markup, ".energy-sheet");
}

export function patchUpgradeConfirmation(host: HTMLElement, markup: string): void {
  patchSheet(host, markup, ".upgrade-confirm-sheet");
}
